(() => {
  let lastTrigger = null;

  const loadModalImages = (dialog) => {
    dialog.querySelectorAll('img[data-rehair-modal-src]').forEach((image) => {
      if (image.src) return;
      image.src = image.dataset.rehairModalSrc;
      image.loading = 'lazy';
      image.removeAttribute('data-rehair-modal-src');
    });
  };

  const track = (action, modal) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'rehair_product_color_help',
      color_help_action: action,
      color_help_modal: modal
    });
  };

  const closeDialog = (dialog, restoreFocus = true) => {
    if (!dialog) return;
    dialog.hidden = true;

    if (!document.querySelector('[data-rehair-product-modal]:not([hidden])')) {
      document.documentElement.classList.remove('rehair-product-modal-open');
    }

    if (restoreFocus) lastTrigger?.focus();
  };

  const openDialog = (id, action = 'open') => {
    const dialog = document.getElementById(id);
    if (!dialog) return;

    loadModalImages(dialog);
    dialog.hidden = false;
    document.documentElement.classList.add('rehair-product-modal-open');
    dialog.querySelector('[data-rehair-modal-close]')?.focus();
    track(action, id.includes('photo-guide') ? 'photo_guide' : 'color_guide');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rehair-modal-open]');
    if (!button) return;

    lastTrigger = button;
    openDialog(button.dataset.rehairModalOpen);
  });

  const init = () => {
    document.querySelectorAll('[data-rehair-product-modal]').forEach((dialog) => {
      if (dialog.dataset.rehairModalReady === 'true') return;
      dialog.dataset.rehairModalReady = 'true';
      document.body.append(dialog);

      dialog.querySelectorAll('[data-rehair-modal-close]').forEach((button) => {
        button.addEventListener('click', () => closeDialog(dialog));
      });

      dialog.querySelectorAll('[data-rehair-modal-switch]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.rehairModalSwitch;
          closeDialog(dialog, false);
          openDialog(target, 'switch');
        });
      });

      dialog.querySelectorAll('[data-rehair-product-help-action]').forEach((link) => {
        link.addEventListener('click', () => {
          track(link.dataset.rehairProductHelpAction, dialog.id);
        });
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDialog(dialog);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

